import * as React from 'react';
import {Button, CardBody, CardFooter, CardHeader, CardText} from 'reactstrap';
import {IWorkerMessage} from '../../models/interfaces/message/IWorkerMessage';
import {first} from 'rxjs/operators';
import {PageFlowService} from '../../services/PageFlowService';
import {HtmlSanitisationService} from '../../services/HtmlSanitisationService';
import {Context} from '../shared/Context';

export const WorkerMessages = (props: {
    workerMessages: IWorkerMessage[], displayWorkerMessages: boolean, setDisplayWorkerMessages: (value: boolean) => void,
    currentIndex: number, setCurrentIndex: (value: number) => void, history: any
}) => {
    const htmlSanitisationService = new HtmlSanitisationService();
    const pageFlowService = new PageFlowService();

    const context = React.useContext(Context);

    const handleMessageAcknowledgment = () => {
        if (context) {
            if (props.currentIndex + 1 < props.workerMessages.length) {
                props.setCurrentIndex(props.currentIndex + 1);
            } else {
                pageFlowService.redirectToNextPage(context).pipe(first())
                    .subscribe(nextPage => props.history.push(nextPage));
            }
        }
    };

    const getMessage = (): string => {
        if (props.workerMessages[props.currentIndex]) {
            return props.workerMessages[props.currentIndex].message.message;
        }
        return '';
    };

    return (
        <div hidden={!props.displayWorkerMessages}>
            <CardHeader className="border-0">
                (Personal Message)
            </CardHeader>
            <CardBody className="bg-white min-height-10rem">
                <CardText tag={'div'} dangerouslySetInnerHTML={htmlSanitisationService.sanitiseHtml(getMessage())}/>
            </CardBody>
            <CardFooter>
                <div className="w-100 mb-3 text-center">
                    <div>{props.currentIndex + 1} of {props.workerMessages ? props.workerMessages.length : 0}</div>
                </div>
                <Button type="button" className="btn-lg btn-logpoint btn-card font-weight-bold w-100"
                        onClick={handleMessageAcknowledgment}>
                    Acknowledge
                </Button>
            </CardFooter>
        </div>
    );
};
